import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import { lostPaymentHeaders } from "@/constants/defaultHeader";
export default {
	state: {
		lostPaymentFilters: null,
		lostPaymentList: null,
		lostPaymentLimit: null,
		lostPaymentOrder: null,
		lostPaymentSort: null,
		lostPaymentTotal: null,
		lostPaymentTotals: null,
	},
	mutations: {
		updateLostPaymentList(state, { rows, limit, order, sort, total, sum }) {
			const { sum_lost_amount } = sum;
			state.lostPaymentList = rows;
			state.lostPaymentLimit = limit;
			state.lostPaymentOrder = order;
			state.lostPaymentSort = sort;
			state.lostPaymentTotal = total;
			state.lostPaymentTotal = total;
			state.lostPaymentTotals = { id: total, lost_amount: sum_lost_amount, };
		},
		updateLostPaymentFilters(state, { filter }) {
			state.lostPaymentFilters = filter;
		},
	},
	actions: {
		async getLostPayment({ commit, dispatch }, filters) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/lost-payment/list', filters);

				if (data) {
					commit('updateLostPaymentList', data);
					commit('updateSettings', {
						settings: data.settings,
						// settings: lostPaymentHeaders,
						key: requestKeys.LOST_PAYMENTS,
						defaultHeader: lostPaymentHeaders
					});
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getLostPaymentFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/lost-payment/filters', values);
				if (data) commit('updateLostPaymentFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async deleteLostPayment({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/lost-payment/${ id }`);
				if (data && data.status) {
					dispatch('getLostPayment', {});
					dispatch('setAlert', { type: "success", message: "✅ The record has been successfully deleted." });
				}
			} catch (e) {
				console.error(e);
			}
		},

	},
	getters: {
		lostPaymentFilters: (s) => s.lostPaymentFilters,
		lostPaymentList: (s) => s.lostPaymentList,
		lostPaymentTotals: (s) => s.lostPaymentTotals,
		lostPaymentLimit: (s) => s.lostPaymentLimit,
		lostPaymentOrder: (s) => s.lostPaymentOrder,
		lostPaymentSort: (s) => s.lostPaymentSort,
		lostPaymentTotal: (s) => s.lostPaymentTotal,
	}
};
